import { useEffect, useState } from 'react';
import {
	Box,
	Button,
	Heading,
	Spacer,
	Stack,
	Table,
	TableContainer,
	Tbody,
	Td,
	Text,
	Thead,
	Tr,
} from '@chakra-ui/react';
import { getAllClientes } from '../../services/clientes';
import TableItem from '../../components/Clientes/TableItem';
import Layout from '../../components/Layout/Layout';
import { useNavigate } from 'react-router-dom';
import FiltrosClientes from '../../components/Filtros/FiltroClientes';
import { AddIcon } from '@chakra-ui/icons';
import { useCallback } from 'react';
import { useRef } from 'react';

const BuscarClientes = () => {
	const [clientes, setClientes] = useState([]);
	// const [clientesFiltrados, setClientesFiltrados] = useState([]);
	// const [needReload, setNeedReload] = useState(true);
	const navigate = useNavigate();

	const [page, setPage] = useState(1);
	const [loading, setLoading] = useState(false);
	const [hasMore, setHasMore] = useState(true);
	const [filtros, setFiltros] = useState({});

	const loaderRef = useRef(null);

	const loadMoreClientes = useCallback(
		async (pagina, filtrosABuscar) => {
			if (loading || !hasMore) return;
			setLoading(true);
			try {
				const nuevosClientes = await getAllClientes(
					pagina,
					25,
					filtrosABuscar,
				);
				if (nuevosClientes.length < 10) setHasMore(false);

				setClientes(prevClientes => [
					...prevClientes,
					...nuevosClientes,
				]);
				setPage(prevPage => prevPage + 1);
			} catch (error) {
				console.error('Error al cargar más clientes:', error);
				setHasMore(false);
			} finally {
				setLoading(false);
			}
		},
		[hasMore, loading],
	);

	const handleFiltros = ({ target }) => {
		const { value } = target;

		const newFilters = {
			...filtros,
			[target.name]: value,
		};

		setFiltros(newFilters);
		setClientes([]);
		setPage(1);
		setHasMore(true);
		loadMoreClientes(1, newFilters);
	};

	useEffect(() => {
		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					if (entry.isIntersecting) {
						loadMoreClientes(page, filtros);
					}
				});
			},
			{ threshold: 1.0 },
		);

		const currentLoaderRef = loaderRef.current;
		if (currentLoaderRef) {
			observer.observe(currentLoaderRef);

			return () => {
				if (currentLoaderRef) {
					observer.unobserve(currentLoaderRef);
				}
			};
		}
	}, [loadMoreClientes, page, filtros, hasMore, loading]);

	// useEffect(() => {
	// 	const getUsuarios = async () => {
	// 		const users = await getAllClientes();
	// 		// Ordenar por nombre
	// 		users.sort((a, b) => {
	// 			// Ignore upper and lowercase
	// 			const nameA = a.nombre.toUpperCase();
	// 			const nameB = b.nombre.toUpperCase();
	// 			if (nameA < nameB) {
	// 				return -1;
	// 			}
	// 			if (nameA > nameB) {
	// 				return 1;
	// 			}
	// 			// names must be equal
	// 			return 0;
	// 		});
	// 		setClientes(users);
	// 		setNeedReload(false);
	// 	};

	// 	needReload && getUsuarios();
	// }, [needReload]);

	return (
		<Layout>
			<Box w='100%'>
				<Heading textAlign='center' color='blue.800'>
					CLIENTES
				</Heading>
			</Box>
			<Stack direction='row' mt={-10}>
				<Spacer />
				{/* <FiltrosClientes datos={clientes} setDatosFiltrados={setClientesFiltrados} /> */}

				<FiltrosClientes setFiltros={handleFiltros} />

				<Button
					onClick={() => navigate('/clientes/crear')}
					colorScheme='blue'
					rounded='none'
				>
					<AddIcon />
				</Button>
			</Stack>

			<Box mt={6}>
				<TableContainer
					w='100%'
					border='1px'
					borderColor='blue.400'
					rounded='lg'
					shadow='dark-lg'
				>
					<Table size='lg' p={4}>
						<Thead bgColor='blue.100'>
							<Tr>
								<Td>Tipo de cliente</Td>
								<Td>Cliente</Td>
								<Td>Tipo identificador</Td>
								<Td>Identificador</Td>
								<Td>Dirección</Td>
								<Td>Telefono</Td>
								<Td>Correo</Td>
							</Tr>
						</Thead>
						<Tbody>
							{clientes &&
								clientes.map(usuario => {
									return (
										<TableItem
											key={usuario.uuid}
											usuario={usuario}
										/>
									);
								})}
						</Tbody>
					</Table>
				</TableContainer>
				<Box ref={loaderRef} height='40px' />
				{loading && (
					<Text textAlign='center' mt={4}>
						Cargando...
					</Text>
				)}
				{!hasMore && (
					<Text textAlign='center' mt={4}>
						No hay más clientes para mostrar.
					</Text>
				)}
			</Box>
		</Layout>
	);
};

export default BuscarClientes;
